import { Group, type BoxProps } from "@mantine/core";
import { IconBulb } from "@tabler/icons-react";
import ReactMarkdown from "react-markdown";
import "./FormFieldInfoText.scss";

interface FormFieldInfoTextProps extends BoxProps {
  infoText: string;
}

function FormFieldInfoText({ infoText, ...props }: FormFieldInfoTextProps) {
  return (
    <Group className="FormFieldInfoText" my="sm" wrap="nowrap" {...props}>
      <IconBulb color="var(--mantine-primary-color-filled)" />
      <ReactMarkdown>{infoText}</ReactMarkdown>
    </Group>
  );
}

export { FormFieldInfoText, FormFieldInfoTextProps };
